<template>
    <li class="nav-item dropdown dropdown-notification mr-25">
        <a class="nav-link" href="javascript:void(0);" data-toggle="dropdown">
            <i class="ficon" data-feather="bell"></i>
            <span v-if="unreadNotificationsCount > 0" class="badge badge-pill badge-danger badge-up">{{
                unreadNotificationsCount }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right">
            <li class="dropdown-menu-header">
                <div class="dropdown-header d-flex">
                    <h4 class="notification-title mb-0 mr-auto">
                        Notifications
                    </h4>
                    <div v-if="unreadNotificationsCount > 0" class="badge badge-pill badge-light-primary">
                        {{ unreadNotificationsCount }} New
                    </div>
                </div>
            </li>
            <li class="scrollable-container media-list">
                <a :style="(notification.read_at == null) ? 'background: #f8f8f8;' : ''"
                    v-for="(notification, index) in notifications" :key="notification.id" class="d-flex"
                    href="javascript:void(0)" v-on:click="MarkAsRead(notification.id)"> <!-- :key="notification.id" -->

                    <div class="media d-flex align-items-start" v-if="notification.data.data.type">
                        <template v-if="notification.data.data.type == 'letterUser'">
                            <div class="media-left">
                                <div class="avatar" style="background-color: transparent;"
                                    v-html="octicons['mail'].toSVG({ 'width': 24 })">
                                </div>
                            </div>
                            <div class="media-body">
                                <span @click="deleteNotification(notification.id)"
                                    class="badge badge-pill badge-danger badge-up cart-item-remove" data-toggle="tooltip"
                                    data-placement="top" title="Delete Notification">
                                    <i data-feather="x"></i>
                                </span>
                                <!-- <i class="ficon cart-item-remove" data-feather="x"></i> -->

                                <p class="media-heading">
                                    <span class="font-weight-bolder">
                                        {{ notification.data.data.letter_name }}

                                    </span>
                                    &nbsp;
                                <div v-if="notification.read_at == null" class="badge badge-pill badge-light-primary">
                                    New
                                </div>
                                </p>
                                <p class="notification-text" style="margin-bottom: 0rem !important;" v-if="notification.data.data.is_client">
                                    was mailed out for
                                    <span class="text-primary font-weight-bolder">{{ notification.data.data.client_name }} &nbsp;</span>
                                    <span v-if="notification.data.data.days_after_mail_out  > 0">
                                        {{ notification.data.data.days_after_mail_out }} <span v-if="notification.data.data.days_after_mail_out > 1"> days </span><span v-else> day </span> ago. Expect a response soon.
                                    </span>
                                </p>
                                <p class="notification-text" style="margin-bottom: 0rem !important;" v-else>
                                    was mailed out
                                    <span v-if="notification.data.data.days_after_mail_out  > 0">
                                         {{ notification.data.data.days_after_mail_out }}  <span v-if="notification.data.data.days_after_mail_out > 1"> days </span><span v-else> day </span> ago. Expect a response soon.
                                    </span>
                                </p>
                            </div>
                        </template>
                        <template v-else-if="notification.data.data?.type == 'client_subscription'">
                            <div class="media-left">
                                <div class="avatar" style="background-color: transparent;"
                                    v-html="octicons['credit-card'].toSVG({ 'width': 24 })">
                                </div>
                            </div>
                            <div class="media-body">
                                <span
                                    @click="deleteNotification(notification.id)"
                                    class="badge badge-pill badge-danger badge-up cart-item-remove"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Delete Notification"
                                >
                                    <i data-feather="x"></i>
                                </span>
                                <p class="media-heading">
                                    <span class="font-weight-bolder">
                                        {{ notification.data.data.title }}
                                    </span>
                                    <div v-if="notification.read_at == null" class="badge badge-pill badge-light-primary">
                                        New
                                    </div>
                                </p>
                                <small class="notification-text" style="margin-bottom: 0rem !important;">
                                    <a
                                        class="text-body"
                                        :href="$router.resolve({ name: 'report', params: notification.data.data.params }).href"
                                    >
                                        {{ notification.data.message }}
                                    </a>
                                </small>
                            </div>
                        </template>
                        <template v-else>
                            <div class="media-left">
                                <div class="avatar" style="background-color: transparent;"
                                    v-html="octicons['checklist'].toSVG({ 'width': 24 })"
                                    v-if="notification.data.data.type == 'Feature'">
                                </div>
                                <div class="avatar" style="background-color: transparent;"
                                    v-html="octicons['image'].toSVG({ 'width': 24 })" v-else></div>
                            </div>
                            <div class="media-body">
                                <span @click="deleteNotification(notification.id)"
                                    class="badge badge-pill badge-danger badge-up cart-item-remove" data-toggle="tooltip"
                                    data-placement="top" title="Delete Notification">
                                    <i data-feather="x"></i>
                                </span>
                                <!-- <i class="ficon cart-item-remove" data-feather="x"></i> -->

                                <p class="media-heading">
                                    <span class="font-weight-bolder">
                                        {{ notification.data.data.post_title }}

                                    </span>
                                    &nbsp;
                                <div v-if="notification.read_at == null" class="badge badge-pill badge-light-primary">
                                    New <span
                                        v-if="notification.data.data.type == 'Feature'">{{ notification.data.data.type }}</span><span
                                        v-else>{{ notification.data.data.type }}</span>
                                </div>
                                </p>
                                <p class="notification-text">
                                    <a class="text-body"
                                        :href="'/blog/' + notification.data.data.category + '/' + notification.data.data.slug">
                                        {{ notification.data.message }}
                                    </a>
                                </p>
                            </div>
                        </template>
                    </div>

                    <div class="media d-flex align-items-start" v-else>
                        <div class="media-left">
                            <div class="avatar" style="background-color: transparent;"
                                v-html="octicons['file-zip'].toSVG({ 'width': 24 })">
                            </div>
                            <!-- <div v-if="notification.type" class="avatar-content">MD</div> -->
                            <!-- <img
                :src="octicons.x.toSVG()"
                alt="avatar"
                width="32"
                height="32"
              /> --> <!-- v-else notification.avatar -->
                        </div>
                        <div class="media-body">
                            <span @click="deleteNotification(notification.id)"
                                class="badge badge-pill badge-danger badge-up cart-item-remove" data-toggle="tooltip"
                                data-placement="top" title="Delete Notification">
                                <i data-feather="x"></i>
                            </span>
                            <!-- <i class="ficon cart-item-remove" data-feather="x"></i> -->

                            <p class="media-heading">
                                <span class="font-weight-bolder">
                                    {{ notification.data.data.title }}

                                </span>
                            <div v-if="notification.read_at == null" class="badge badge-pill badge-light-primary">
                                New
                            </div>
                            </p>
                            <small class="notification-text" style="margin-bottom: 0rem !important;">
                                <a class="text-body"
                                    :href="$router.resolve({ name: 'letter-zip-download-url', params: { 'id': notification.id } }).href">
                                    {{ notification.data.message }}
                                </a>
                            </small>
                        </div>
                    </div>

                </a>
            </li>
            <li class="dropdown-menu-footer"><button class="btn btn-primary btn-block" @click="markAllAsRead">Mark all
                    notifications as read</button></li>
        </ul>
    </li>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import { reactive, ref, computed } from 'vue'

export default {
    components: {
    },
    directives: {
        Ripple,
    },
    props: {
        user: Number
    },
    setup() {
        /* eslint-disable global-require */
        const notifications = ref([]),
            unreadNotificationsCount = ref(0),
            total = ref(0),
            octicons = window.octicons;
        /* eslint-disable global-require */
        const perfectScrollbarSettings = {
            maxScrollbarLength: 60,
            wheelPropagation: false,
        }

        return {
            notifications,
            perfectScrollbarSettings,
            unreadNotificationsCount,
            total,
            octicons
        }
    },
    mounted() {
        this.initialize();
        Echo.private(`user.${this.user}`)
            .notification((notification) => {
                if (notification.error == true) {
                    toastr.error(notification.message, 'Error!');
                }
                else {
                    this.initialize();
                }
            });
    },
    // computed: {
    //   updateNotifications() {
    //     return this.notifications;
    //   },
    // },
    methods: {
        initialize: function () {
            const route = this.$router.resolve(
                {
                    name: 'notification-url',
                }
            );
            axios.get(route.href)
                .then(response => {
                    // this.notifications = [];
                    // this.notifications = response.data.data.data;
                    if (response.data.data.data.length > 0) {
                        this.notifications = response.data.data.data;
                    }
                    else {
                        this.notifications = [];
                    }
                    this.unreadNotificationsCount = response.data.data.unreadNotificationsCount;
                    this.total = response.data.data.total;
                    setTimeout(() => {
                        if (feather) {
                            feather.replace();
                        }
                    }, "100");
                });
        },
        markAllAsRead: function () {
            const route = this.$router.resolve(
                {
                    name: 'notifications-mark-as-read-url',
                }
            );
            axios.get(route.href)
                .then(response => {
                    if (response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                });
        },
        deleteNotification(notificationID) {
            let params = {};
            if (this.$route.params) {
                params.notification = notificationID;
            }
            const route = this.$router.resolve(
                {
                    name: 'notification-delete-url',
                    params: params
                }
            );
            axios.delete(route.href)
                .then(response => {
                    if (response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    // console.log(this.notifications);

                    this.notifications = this.notifications.filter(function (notification) {
                        return notification.id !== notificationID
                    });
                    // console.log(this.notifications);
                    toastr.success(response.data.message, 'Success!');
                });
        },
        MarkAsRead(notificationId) {
            let params = {};
            if (this.$route.params) {
                params.notificationId = notificationId;
            }
            const route = this.$router.resolve(
                {
                    name: 'notification-single-mark-as-read-url',
                    params: params
                }
            );
            axios.put(route.href)
                .then(response => {
                    if (response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                });
        }
    }
}
</script>

<style></style>
